import { cn } from '@/lib/cn'

/**
 * The ALFI brand mark: a red and a blue tile carrying the lettering. The
 * colours are the brand's own and do not follow the colour scheme. The mark is
 * 1600:780, so size it by height; the width follows.
 */
export function LogoMark({ className }: { className?: string }) {
  return (
    <svg viewBox="214.5 129.5 1600 780" className={cn('aspect-1600/780 h-8.5 w-auto shrink-0', className)} aria-hidden>
      <rect x="214.5" y="129.5" width="800.5" height="780" rx="143" fill="#F10D19" />
      <rect x="1015" y="129.5" width="799.5" height="780" rx="143" fill="#0158C5" />
      <g fill="#FCFCFC" transform="translate(0,-22)">
        <path d="M278 731C261 731 251 719 260 702L412 387C424 362 445 351 477 351C509 351 531 360 542 386L688 700C696 718 688 731 670 731H601C588 731 580 725 575 714L476.5 498.5L374 713C368 726 362 731 349 731Z" />
        <path d="M719 354H776C792 354 802 364 802 380V599C802 617 812 627 831 627H947C964 627 974 637 974 654V705C974 722 964 731 947 731H813C744 731 693 680 693 610V380C693 363 702 354 719 354Z" />
        <g transform="translate(-26,0)">
          <path d="M1287 354H1549C1566 354 1575 363 1575 380V424C1575 442 1566 451 1549 451H1308C1283 451 1271 464 1271 489V517H1516C1534 517 1543 526 1543 543V583C1543 601 1534 610 1516 610H1271V705C1271 722 1262 731 1245 731H1187C1170 731 1161 722 1161 705V482C1161 411 1217 354 1287 354Z" />
          <rect x="1610.5" y="354" width="109.5" height="377" rx="26" />
        </g>
      </g>
    </svg>
  )
}
